import '../styles/CustomRadioButton.css';
import CustomTooltip from './CustomTooltip';
import info from '../images/info.svg';
import PropTypes from 'prop-types';

const CustomRadioButton = ({label, id, name, value, checked, tooltipMessageId, onChange}) => {
  return (
    <label className="radio">
      <input type="radio" name={name} checked={checked} onChange={onChange} id={id} value={value} />
      <span>{label}</span>
      <CustomTooltip tooltipMessageId={tooltipMessageId}>
        <img src={info} alt="Info Icon" style={{width: '16px', height: '16px'}} />
      </CustomTooltip>
    </label>
  );
};

CustomRadioButton.propTypes = {
  label: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  tooltip: PropTypes.string,
  onChange: PropTypes.func.isRequired
};

export default CustomRadioButton;
